module.exports = "/_next/static/images/hishu-fd96686de300199e705de0ebb5d35864.svg";